<template>
  <v-container fill-height fluid>
    <v-row class="text-center" justify="center">
      <v-col cols="12" sm="12" md="10" lg="8" xl="8">
        <ConsentsComponent :languagestrings="languagestrings" :toperror="toperror" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  //style="margin-top: -20px;"
  import ConsentsComponent from '../components/ConsentsComponent';

  export default {
    name: 'ConsentsView',

    components: {
      ConsentsComponent,
    },

    props: ['languagestrings', 'toperror'],
    
    methods: {
      updateLanguage(language) {
        this.$emit("updateLanguage", language);
      }
    }

  }
</script>
